<!-- 中保车服  第三方信息共享清单 -->
<template>
  <div class="shared-wrap">

    <div class="first-level top-space">1、中原农业保险股份有限公司</div>
    <div class="content-wrap">
      <p>功能类型：<span class="desc-wrap">查勘、定损</span></p>
      <p>使用目的：<span class="desc-wrap">对保险公司申请使用查勘、定损的保险事故车主进行服务</span></p>
      <p>共享方式：<span class="desc-wrap">授权后通过数据接口（API）共享至第三方</span></p>
      <p>收集的个人信息种类：<span class="desc-wrap">姓名、手机号  </span></p>
      <p>存储期限：<span class="desc-wrap">服务存续期间</span></p>
      <p>存储地点：<span class="desc-wrap">第三方服务器（境内）</span></p>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SharedList',
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.shared-wrap {
  font-size: 16px;
  background: white;
  padding: 0 16px 24px 16px;
  color: #383838;

  .first-level  {
    font-weight: 500;
    line-height: 40px;
  }
  .desc-wrap {
    font-weight: 400;
    color: #646464;
  }

  .content-wrap {
    color: #383838;
    line-height: 26px;
    font-weight: 500;
    font-size: 15px;
  }

  .top-space {
    margin-top: 16px;
    font-size: 16px;
  }
}
</style>
